var $486ce11931c9769b$exports = {};
$486ce11931c9769b$exports = {
    "(optional)": `(valfritt)`,
    "(required)": `(kr\xe4vs)`
};


export {$486ce11931c9769b$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
